import { TierType } from 'global-services/constants/OhsObject';
import { OhsUser } from 'user/OhsUser';

export default class OhsExportCentreFilterModels {
  viewPreset: 'view_1' | 'view_2';

  archived: boolean;

  count: boolean;

  sort: string;

  scheduleType: string[];

  owner: {
    type: 'core.module.export.template' | 'core.module.correspondence.roll';
    _id: string;
  };

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor(user: OhsUser | undefined) {
    this.viewPreset = user?.tier.type === TierType.T3 ? 'view_1' : 'view_2';
    this.archived = false;
    this.count = false;
    this.scheduleType = [];
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Created Order: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Created Order: Oldest to Newest ', value: '{ "key": "_id", "order": 1 }' },
      ],
    };
    this.owner = { type: 'core.module.export.template', _id: '' };
    this.sort = '{ "key": "_id", "order": -1 }';
  }
}
